export default {
    init() {
        $(document).on("click", "[data-sidebar_toggle]", function (event) {
            event.preventDefault();
            $("[data-sidebar]").toggleClass("collapsed");
            $("body").toggleClass("sidebar-collapsed");
        });
    },
};
